import { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import _ from 'lodash';
//components
import FormCreator from 'components/FormCreator';
import { setListOfInvalids } from 'components/FormCreator/validation';
import { fieldsGroupType, fieldType, invalidFields, validationTypes } from 'components/FormCreator/types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { userFieldsValidations, FormInputsTypes } from 'constants/settings.constants';
import UserEditCard from './UserEditCard';
import { changeUserData } from 'services/user.services';
import { API_UPDATE_CONTACT_PHONE } from 'constants/db.constants';
import { validateFields } from 'components/FormCreator/validation';

export default function EditPhone({ handleCancelEdit }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const [currentPhone, setCurrentPhone] = useState('');
	const [newPhone, setNewPhone] = useState('');
	const [newPhoneConfirmation, setNewPhoneConfirmation] = useState('');
	const prefixFields = 'forms.settings.user_edit.';

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		updateInput(name, value);
		if (_.has(userFieldsValidations, name)) {
			setInvalidFields(setListOfInvalids(invalidFields, userFieldsValidations, name, value));
		}
	};

	const updateInput = (name, value) => {
		if (name === 'currentPhone') {
			setCurrentPhone(value);
		} else if (name === 'newPhone') {
			setNewPhone(value);
		} else {
			setNewPhoneConfirmation(value);
		}
	};

	const handleSaveCLick = () => {
		let obj = {};
		_.keys(userFieldsValidations).forEach((key) => {
			obj = {
				...obj,
				['currentPhone']: currentPhone,
				['newPhone']: newPhone,
				['newPhoneConfirmation']: newPhoneConfirmation,
			};
		});
		const invalidFields = validateFields(userFieldsValidations, obj);
		if (_.keys(invalidFields).length) {
			setInvalidFields(invalidFields);
		} else {
			const formData = new FormData();
			formData.append('currentPhone', String(currentPhone));
			formData.append('newPhone', String(newPhone));
			formData.append('newPhoneConfirmation', String(newPhoneConfirmation));
			dispatch(
				changeUserData(
					{ currentPhone, newPhone, newPhoneConfirmation },
					formData,
					FormInputsTypes.PHONE,
					API_UPDATE_CONTACT_PHONE
				)
			);
		}
	};

	const [invalidFields, setInvalidFields] = useState<invalidFields>({});

	return (
		<UserEditCard
			handleSaveClick={handleSaveCLick}
			handleCancelEdit={handleCancelEdit}
			title={t('page.settings.form.title.user_phone')}
			cancelButtonText={t('portal.actions.cancel')}
			saveButtonText={t('portal.actions.save')}
		>
			<FormCreator
				initialValidation={invalidFields}
				name="contactPhone"
				handleChange={handleChange}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: [
							{
								type: fieldType.text,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: 'currentPhone',
									label: t(`${prefixFields}currentPhone`),
									placeholder: 'e.g. test@gmail.com',
									value: currentPhone,
								},
							},
							{
								type: fieldType.text,
								props: {
									required: true,
									name: 'newPhone',
									label: t(`${prefixFields}newPhone`),
									placeholder: 'e.g. test@gmail.com',
									value: newPhone,
								},
							},
							{
								type: fieldType.text,
								props: {
									required: true,
									name: 'newPhoneConfirmation',
									label: t(`${prefixFields}newPhoneConfirmation`),
									placeholder: 'e.g. test@gmail.com',
									value: newPhoneConfirmation,
								},
							},
						],
					},
				]}
			/>
		</UserEditCard>
	);
}
